import {CommonService} from '../../../services/common.service';
import {Component, Inject, OnInit, ViewChild} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef, MatPaginator, MatSort, MatTableDataSource} from '@angular/material';
import {ToastMessagesService} from '../../../services/toast-messages.service';

@Component({
  styleUrls: ['./merging-dialog.component.scss'],
  templateUrl: './merging-dialog.component.html'
})
export class MergingDialogComponent implements OnInit {
  salePoints: MatTableDataSource<any>;
  displayColumns = ['key1', 'id', 'customer_code', 'customer_name', 'vat_number', 'address', 'postal_code', 'division_id', 'division_name', 'sales_group_id', 'sales_group_name', 'actions'];
  displayMiniColumns = ['key1', 'id', 'customer_name', 'vat_number', 'sales_group_name'];

  @ViewChild(MatSort, {static: true}) sort: MatSort;
  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;
  keepSalePoint: any;
  keepSalePointDataSource: MatTableDataSource<any> = new MatTableDataSource<any>();
  mergeSalePoint: any[] = [];
  mergeSalePointDataSource: MatTableDataSource<any> = new MatTableDataSource<any>();
  isLoading = false;
  hasChanges = false;

  constructor(private commonService: CommonService,
              private matDialogRef: MatDialogRef<MergingDialogComponent>,
              private toastMessagesService: ToastMessagesService,
              @Inject(MAT_DIALOG_DATA) public data: any) {
    for (const salePoint of data.salePoints) {
      salePoint.keep = false;
      salePoint.merge = false;
    }
    this.salePoints = new MatTableDataSource<any>(data.salePoints);
    this.salePoints.paginator = this.paginator;
  }

  public ngOnInit(): void {
    this.paginator = this.commonService.setPaginatorTexts(this.paginator);
    this.salePoints.paginator = this.paginator;
  }

  keep(element: any) {
    const tempKeepData = [];
    for (const salePoint of this.salePoints.data as any[]) {
      salePoint.keep = false;
    }
    element.keep = true;
    element.merge = false;
    this.keepSalePoint = element;
    tempKeepData.push(element);
    this.keepSalePointDataSource = new MatTableDataSource<any>(tempKeepData);
  }

  merge(element: any) {
    if (this.keepSalePoint && this.keepSalePoint.id === element.id) {
      this.keepSalePoint = null;
    }
    element.keep = false;
    element.merge = true;
    const index = this.mergeSalePoint.findIndex(sp => sp.id === element.id);
    if (index === -1) {
      this.mergeSalePoint.push(element);
    }

    this.mergeSalePointDataSource = new MatTableDataSource<any>(this.mergeSalePoint);
  }

  close() {
    this.matDialogRef.close(this.hasChanges);
  }

  clear(element: any) {
    element.keep = false;
    element.merge = false;
    if (this.keepSalePoint && this.keepSalePoint.id === element.id) {
      this.keepSalePoint = null;
      this.keepSalePointDataSource = new MatTableDataSource<any>([]);
    }
    const index = this.mergeSalePoint.findIndex(sp => sp.id === element.id);
    if (index !== -1) {
      this.mergeSalePoint.splice(index, 1);
      this.mergeSalePointDataSource = new MatTableDataSource<any>(this.mergeSalePoint);
    }
  }

  async startMerging() {
    try {
      this.isLoading = true;

      const tempSalePoints = this.salePoints.data as any[];
      for (const sp of this.mergeSalePoint) {
        const model = {
          main_sale_point_id: this.keepSalePoint.id,
          merged_sale_point_id: sp.id
        };
        await this.commonService.updateObject(`sale_point/merge`, model);
        const index = tempSalePoints.findIndex(s => s.id === sp.id);
        if (index !== -1) {
          tempSalePoints.splice(index, 1);
        }
      }

      this.salePoints = new MatTableDataSource<any>(tempSalePoints);
      this.salePoints.paginator = this.paginator;
      this.mergeSalePoint = [];
      this.hasChanges = true;
      this.toastMessagesService.toastMessages('Η συγχώνευση ολοκληρώθηκε με επιτυχία.');
    } catch (e) {
      this.toastMessagesService.toastErrorMessage(e.message);
    } finally {
      this.isLoading = false;
    }
  }

  shouldBeDisabled() {
    return !(this.keepSalePoint && this.mergeSalePoint.length > 0 && !this.isLoading);
  }

  public setTableHeight(): number {
    return window.innerHeight - 403;
  }

  setMainTableHeight() {
    return window.innerHeight - 50;
  }
}
